"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * A Component implementing a bootstrap card with internal tabs in the header
 */
var TabCard = /*#__PURE__*/
function (_React$Component) {
  _inherits(TabCard, _React$Component);
  function TabCard() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TabCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabCard)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedIndex: _this.props.selectedIndex > 0 ? _this.props.selectedIndex : 0
    });
    _defineProperty(_assertThisInitialized(_this), "onTabSelect", function (e, selectedKey) {
      e.preventDefault();
      _this.setState({
        selectedIndex: selectedKey
      });
      if (_this.props.onSelect) {
        _this.props.onSelect(e, selectedKey);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getTabClass", function (index) {
      return index === _this.state.selectedIndex ? 'nav-item active' : 'nav-item';
    });
    _defineProperty(_assertThisInitialized(_this), "renderTab", function (tabInfo, tabIndex) {
      return _react["default"].createElement("li", {
        key: tabIndex,
        className: _this.getTabClass(tabIndex)
      }, _react["default"].createElement("a", {
        href: tabInfo.href || null,
        className: "nav-link",
        onClick: function onClick(e) {
          return _this.onTabSelect(e, tabIndex);
        }
      }, _react["default"].createElement("strong", null, " ", tabInfo.name, " ")));
    });
    _defineProperty(_assertThisInitialized(_this), "renderTabNav", function () {
      return _react["default"].createElement("ul", {
        className: "nav card-tab-nav"
      }, " ", _this.props.tabs.map(_this.renderTab), " ");
    });
    _defineProperty(_assertThisInitialized(_this), "renderFooter", function () {
      if (_this.props.tabs[_this.state.selectedIndex].footer) {
        return _react["default"].createElement("div", {
          className: "card-footer"
        }, " ", _this.props.tabs[_this.state.selectedIndex].footer, " ");
      }
      return null;
    });
    return _this;
  }
  _createClass(TabCard, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (nextProps.selectedIndex >= 0 && this.state.selectedIndex !== nextProps.selectedIndex) {
        this.setState({
          selectedIndex: nextProps.selectedIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "card tab-card"
      }, _react["default"].createElement("div", {
        className: "card-header card-tabs"
      }, this.renderTabNav()), _react["default"].createElement("div", {
        className: "card-block"
      }, this.props.tabs[this.state.selectedIndex].block), this.renderFooter());
    }
  }]);
  return TabCard;
}(_react["default"].Component);
exports["default"] = TabCard;
TabCard.propTypes = {
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].node.isRequired,
    block: _propTypes["default"].node.isRequired,
    footer: _propTypes["default"].node,
    href: _propTypes["default"].string
  })),
  onSelect: _propTypes["default"].func,
  selectedIndex: _propTypes["default"].number
};
TabCard.defaultProps = {
  tabs: [],
  onSelect: function onSelect() {},
  selectedIndex: undefined
};